import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { collaborationApi, type DirectoryEntry } from '../../api/collaboration';

export function MemberSearchPage() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<DirectoryEntry[]>([]);
  const [count, setCount] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function search(e?: React.FormEvent) {
    e?.preventDefault();
    if (!query.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await collaborationApi.search(query.trim());
      setResults(res.results);
      setCount(res.count);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Search failed');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (query.trim()) void search();
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/members" className="text-sm text-slate-600 hover:underline">← Member directory</Link>
      <h1 className="mt-4 text-2xl font-semibold">Member Search</h1>
      <form onSubmit={(e) => void search(e)} className="mt-6 flex gap-3">
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search by name, email, or identity…"
          className="flex-1 rounded-lg border px-3 py-2"
          aria-label="Member search query"
        />
        <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Search</button>
      </form>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {loading ? <p className="mt-6">Searching…</p> : (
        <>
          {count > 0 && <p className="mt-4 text-sm text-slate-500">{count} result{count === 1 ? '' : 's'}</p>}
          <ul className="mt-4 space-y-3">
            {results.map((entry) => (
              <li key={entry.membership.id} className="rounded-xl border bg-white p-4">
                <p className="font-medium">{entry.display_name || entry.membership.identity_id}</p>
                <p className="text-sm text-slate-500">{entry.email || entry.membership.identity_id}</p>
                <p className="mt-1 text-xs capitalize text-slate-400">{entry.membership.scope.type} · {entry.membership.status}</p>
                <Link to={`/members/${entry.membership.id}`} className="mt-2 inline-block text-sm text-slate-700 hover:underline">View details</Link>
              </li>
            ))}
            {!loading && results.length === 0 && query && <p className="text-slate-500">No members match your search.</p>}
          </ul>
        </>
      )}
    </div>
  );
}
